export const newAlert = (state, payload) => {
  if (state.supress) { return }
  let alert = {
    details: payload,
    request: payload.request
  }
  delete alert.details.request // get rid of the request in details
  state.alerts.push(alert)
}
export const hideAlert = (state, index) => {
  state.alerts.splice(index, 1)
}
export const newNotification = (state, payload) => {
  if (state.supress) { return }
  state.notifications.push(payload)
  setTimeout(() => {
    state.notifications.shift() // remove oldest
  }, 5000)
}
export const hideNotification = (state, index) => {
  state.notifications.splice(index, 1)
}
export const setValidation = (state, payload) => {
  state.validation = payload
}
export const setSupress = (state, payload) => {
  state.supress = payload
}
